<template>
  <div class="rowCell">
    <div class="cellCol big">
      <el-avatar
        style="display: block"
        shape="square"
        :size="80"
        :src="'/forum-pub-api/v1/minio/getFile?file_url=' + avatar"
      ></el-avatar>
      <div>{{ memberName }}</div>
    </div>
    <div class="cellCol">
      <div style="text-align: left">
        <label style="margin-right: 5px">简介:</label
        ><span v-html="information"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RowCell',
  props: {
    avatar: String,
    memberName: String,
    proTitle: String,
    memberOrg: String,
    information: String,
  },
};
</script>

<style scoped></style>
